// World Cup 2026 - Programme complet + Normalisation intelligente
// Détecte: M1, M57, 057, match 57, etc.

// World Cup 2026 Matches - Complete Schedule
export const WC_MATCHES = [
  // Group Stage - Day 1 (June 11, 2026)
  { matchNum: 1, date: "11/06/2026", teams: "Mexico vs TBD", stage: "Group A", venue: "Estadio Azteca", city: "Mexico City" },
  { matchNum: 2, date: "11/06/2026", teams: "USA vs TBD", stage: "Group B", venue: "SoFi Stadium", city: "Los Angeles" },
  
  // Group Stage - Day 2 (June 12, 2026)
  { matchNum: 3, date: "12/06/2026", teams: "Canada vs TBD", stage: "Group C", venue: "BMO Field", city: "Toronto" },
  { matchNum: 4, date: "12/06/2026", teams: "TBD vs TBD", stage: "Group A", venue: "AT&T Stadium", city: "Dallas" },
  { matchNum: 5, date: "12/06/2026", teams: "TBD vs TBD", stage: "Group B", venue: "MetLife Stadium", city: "New York/New Jersey" },
  { matchNum: 6, date: "12/06/2026", teams: "TBD vs TBD", stage: "Group C", venue: "Mercedes-Benz Stadium", city: "Atlanta" },
  
  // Group Stage - Days 3-18 (June 13-28, 2026) - Sample matches
  { matchNum: 7, date: "13/06/2026", teams: "TBD vs TBD", stage: "Group D", venue: "Hard Rock Stadium", city: "Miami" },
  { matchNum: 8, date: "13/06/2026", teams: "TBD vs TBD", stage: "Group D", venue: "NRG Stadium", city: "Houston" },
  { matchNum: 9, date: "13/06/2026", teams: "TBD vs TBD", stage: "Group E", venue: "Lincoln Financial Field", city: "Philadelphia" },
  { matchNum: 10, date: "13/06/2026", teams: "TBD vs TBD", stage: "Group E", venue: "Lumen Field", city: "Seattle" },
  
  { matchNum: 11, date: "14/06/2026", teams: "TBD vs TBD", stage: "Group F", venue: "Levi's Stadium", city: "San Francisco" },
  { matchNum: 12, date: "14/06/2026", teams: "TBD vs TBD", stage: "Group F", venue: "Arrowhead Stadium", city: "Kansas City" },
  { matchNum: 13, date: "14/06/2026", teams: "TBD vs TBD", stage: "Group G", venue: "Gillette Stadium", city: "Boston" },
  { matchNum: 14, date: "14/06/2026", teams: "TBD vs TBD", stage: "Group G", venue: "BC Place", city: "Vancouver" },
  
  { matchNum: 15, date: "15/06/2026", teams: "TBD vs TBD", stage: "Group H", venue: "Estadio BBVA", city: "Monterrey" },
  { matchNum: 16, date: "15/06/2026", teams: "TBD vs TBD", stage: "Group H", venue: "Estadio Akron", city: "Guadalajara" },
  { matchNum: 17, date: "15/06/2026", teams: "TBD vs TBD", stage: "Group A", venue: "Estadio Azteca", city: "Mexico City" },
  { matchNum: 18, date: "15/06/2026", teams: "TBD vs TBD", stage: "Group B", venue: "SoFi Stadium", city: "Los Angeles" },
  
  // Continue with remaining group stage matches (19-48)
  { matchNum: 19, date: "16/06/2026", teams: "TBD vs TBD", stage: "Group C", venue: "BMO Field", city: "Toronto" },
  { matchNum: 20, date: "16/06/2026", teams: "TBD vs TBD", stage: "Group D", venue: "Hard Rock Stadium", city: "Miami" },
  { matchNum: 21, date: "16/06/2026", teams: "TBD vs TBD", stage: "Group E", venue: "Lincoln Financial Field", city: "Philadelphia" },
  { matchNum: 22, date: "16/06/2026", teams: "TBD vs TBD", stage: "Group F", venue: "Levi's Stadium", city: "San Francisco" },
  { matchNum: 23, date: "17/06/2026", teams: "TBD vs TBD", stage: "Group G", venue: "Gillette Stadium", city: "Boston" },
  { matchNum: 24, date: "17/06/2026", teams: "TBD vs TBD", stage: "Group H", venue: "Estadio BBVA", city: "Monterrey" },
  
  { matchNum: 25, date: "17/06/2026", teams: "TBD vs TBD", stage: "Group A", venue: "AT&T Stadium", city: "Dallas" },
  { matchNum: 26, date: "18/06/2026", teams: "TBD vs TBD", stage: "Group B", venue: "MetLife Stadium", city: "New York/New Jersey" },
  { matchNum: 27, date: "18/06/2026", teams: "TBD vs TBD", stage: "Group C", venue: "Mercedes-Benz Stadium", city: "Atlanta" },
  { matchNum: 28, date: "18/06/2026", teams: "TBD vs TBD", stage: "Group D", venue: "NRG Stadium", city: "Houston" },
  { matchNum: 29, date: "19/06/2026", teams: "TBD vs TBD", stage: "Group E", venue: "Lumen Field", city: "Seattle" },
  { matchNum: 30, date: "19/06/2026", teams: "TBD vs TBD", stage: "Group F", venue: "Arrowhead Stadium", city: "Kansas City" },
  
  { matchNum: 31, date: "19/06/2026", teams: "TBD vs TBD", stage: "Group G", venue: "BC Place", city: "Vancouver" },
  { matchNum: 32, date: "20/06/2026", teams: "TBD vs TBD", stage: "Group H", venue: "Estadio Akron", city: "Guadalajara" },
  { matchNum: 33, date: "20/06/2026", teams: "TBD vs TBD", stage: "Group A", venue: "Estadio Azteca", city: "Mexico City" },
  { matchNum: 34, date: "20/06/2026", teams: "TBD vs TBD", stage: "Group A", venue: "AT&T Stadium", city: "Dallas" },
  { matchNum: 35, date: "21/06/2026", teams: "TBD vs TBD", stage: "Group B", venue: "SoFi Stadium", city: "Los Angeles" },
  { matchNum: 36, date: "21/06/2026", teams: "TBD vs TBD", stage: "Group B", venue: "MetLife Stadium", city: "New York/New Jersey" },
  
  { matchNum: 37, date: "21/06/2026", teams: "TBD vs TBD", stage: "Group C", venue: "BMO Field", city: "Toronto" },
  { matchNum: 38, date: "22/06/2026", teams: "TBD vs TBD", stage: "Group C", venue: "Mercedes-Benz Stadium", city: "Atlanta" },
  { matchNum: 39, date: "22/06/2026", teams: "TBD vs TBD", stage: "Group D", venue: "Hard Rock Stadium", city: "Miami" },
  { matchNum: 40, date: "22/06/2026", teams: "TBD vs TBD", stage: "Group D", venue: "NRG Stadium", city: "Houston" },
  { matchNum: 41, date: "23/06/2026", teams: "TBD vs TBD", stage: "Group E", venue: "Lincoln Financial Field", city: "Philadelphia" },
  { matchNum: 42, date: "23/06/2026", teams: "TBD vs TBD", stage: "Group E", venue: "Lumen Field", city: "Seattle" },
  
  { matchNum: 43, date: "23/06/2026", teams: "TBD vs TBD", stage: "Group F", venue: "Levi's Stadium", city: "San Francisco" },
  { matchNum: 44, date: "24/06/2026", teams: "TBD vs TBD", stage: "Group F", venue: "Arrowhead Stadium", city: "Kansas City" },
  { matchNum: 45, date: "24/06/2026", teams: "TBD vs TBD", stage: "Group G", venue: "Gillette Stadium", city: "Boston" },
  { matchNum: 46, date: "24/06/2026", teams: "TBD vs TBD", stage: "Group G", venue: "BC Place", city: "Vancouver" },
  { matchNum: 47, date: "25/06/2026", teams: "TBD vs TBD", stage: "Group H", venue: "Estadio BBVA", city: "Monterrey" },
  { matchNum: 48, date: "25/06/2026", teams: "TBD vs TBD", stage: "Group H", venue: "Estadio Akron", city: "Guadalajara" },
  
  // Round of 32 (matches 49-64) - June 28 - July 2, 2026
  { matchNum: 49, date: "28/06/2026", teams: "1A vs 2B", stage: "Round of 32", venue: "SoFi Stadium", city: "Los Angeles" },
  { matchNum: 50, date: "28/06/2026", teams: "1C vs 2D", stage: "Round of 32", venue: "MetLife Stadium", city: "New York/New Jersey" },
  { matchNum: 51, date: "28/06/2026", teams: "1E vs 2F", stage: "Round of 32", venue: "AT&T Stadium", city: "Dallas" },
  { matchNum: 52, date: "29/06/2026", teams: "1G vs 2H", stage: "Round of 32", venue: "Hard Rock Stadium", city: "Miami" },
  { matchNum: 53, date: "29/06/2026", teams: "1B vs 2A", stage: "Round of 32", venue: "Estadio Azteca", city: "Mexico City" },
  { matchNum: 54, date: "29/06/2026", teams: "1D vs 2C", stage: "Round of 32", venue: "Mercedes-Benz Stadium", city: "Atlanta" },
  { matchNum: 55, date: "30/06/2026", teams: "1F vs 2E", stage: "Round of 32", venue: "NRG Stadium", city: "Houston" },
  { matchNum: 56, date: "30/06/2026", teams: "1H vs 2G", stage: "Round of 32", venue: "Lincoln Financial Field", city: "Philadelphia" },
  { matchNum: 57, date: "30/06/2026", teams: "Japan vs TBD", stage: "Round of 32", venue: "Lumen Field", city: "Seattle" },
  { matchNum: 58, date: "01/07/2026", teams: "TBD vs TBD", stage: "Round of 32", venue: "Levi's Stadium", city: "San Francisco" },
  { matchNum: 59, date: "01/07/2026", teams: "TBD vs TBD", stage: "Round of 32", venue: "BMO Field", city: "Toronto" },
  { matchNum: 60, date: "01/07/2026", teams: "TBD vs TBD", stage: "Round of 32", venue: "Arrowhead Stadium", city: "Kansas City" },
  { matchNum: 61, date: "02/07/2026", teams: "TBD vs TBD", stage: "Round of 32", venue: "Gillette Stadium", city: "Boston" },
  { matchNum: 62, date: "02/07/2026", teams: "TBD vs TBD", stage: "Round of 32", venue: "BC Place", city: "Vancouver" },
  { matchNum: 63, date: "02/07/2026", teams: "TBD vs TBD", stage: "Round of 32", venue: "Estadio BBVA", city: "Monterrey" },
  { matchNum: 64, date: "02/07/2026", teams: "TBD vs TBD", stage: "Round of 32", venue: "Estadio Akron", city: "Guadalajara" },
  
  // Round of 16 (matches 65-72) - July 4-7, 2026
  { matchNum: 65, date: "04/07/2026", teams: "W49 vs W50", stage: "Round of 16", venue: "MetLife Stadium", city: "New York/New Jersey" },
  { matchNum: 66, date: "04/07/2026", teams: "W51 vs W52", stage: "Round of 16", venue: "SoFi Stadium", city: "Los Angeles" },
  { matchNum: 67, date: "05/07/2026", teams: "W53 vs W54", stage: "Round of 16", venue: "AT&T Stadium", city: "Dallas" },
  { matchNum: 68, date: "05/07/2026", teams: "W55 vs W56", stage: "Round of 16", venue: "Estadio Azteca", city: "Mexico City" },
  { matchNum: 69, date: "06/07/2026", teams: "W57 vs W58", stage: "Round of 16", venue: "Hard Rock Stadium", city: "Miami" },
  { matchNum: 70, date: "06/07/2026", teams: "W59 vs W60", stage: "Round of 16", venue: "Mercedes-Benz Stadium", city: "Atlanta" },
  { matchNum: 71, date: "07/07/2026", teams: "W61 vs W62", stage: "Round of 16", venue: "NRG Stadium", city: "Houston" },
  { matchNum: 72, date: "07/07/2026", teams: "W63 vs W64", stage: "Round of 16", venue: "Lincoln Financial Field", city: "Philadelphia" },
  
  // Quarterfinals (matches 73-76) - July 10-11, 2026
  { matchNum: 73, date: "10/07/2026", teams: "W65 vs W66", stage: "Quarterfinal", venue: "MetLife Stadium", city: "New York/New Jersey" },
  { matchNum: 74, date: "10/07/2026", teams: "W67 vs W68", stage: "Quarterfinal", venue: "SoFi Stadium", city: "Los Angeles" },
  { matchNum: 75, date: "11/07/2026", teams: "W69 vs W70", stage: "Quarterfinal", venue: "AT&T Stadium", city: "Dallas" },
  { matchNum: 76, date: "11/07/2026", teams: "W71 vs W72", stage: "Quarterfinal", venue: "Estadio Azteca", city: "Mexico City" },
  
  // Semifinals (matches 77-78) - July 14-15, 2026
  { matchNum: 77, date: "14/07/2026", teams: "W73 vs W74", stage: "Semifinal", venue: "MetLife Stadium", city: "New York/New Jersey" },
  { matchNum: 78, date: "15/07/2026", teams: "W75 vs W76", stage: "Semifinal", venue: "AT&T Stadium", city: "Dallas" },
  
  // Third Place Match (match 79) - July 18, 2026
  { matchNum: 79, date: "18/07/2026", teams: "L77 vs L78", stage: "Third Place", venue: "Hard Rock Stadium", city: "Miami" },
  
  // Final (match 80) - July 19, 2026
  { matchNum: 80, date: "19/07/2026", teams: "W77 vs W78", stage: "Final", venue: "MetLife Stadium", city: "New York/New Jersey" },
];

// Alias mapping for venues
const VENUE_ALIASES = {
  // Mexico
  "azteca": "Estadio Azteca",
  "mexico city": "Estadio Azteca",
  "cdmx": "Estadio Azteca",
  "estadio azteca": "Estadio Azteca",
  "bbva": "Estadio BBVA",
  "monterrey": "Estadio BBVA",
  "akron": "Estadio Akron",
  "guadalajara": "Estadio Akron",
  "chivas": "Estadio Akron",
  
  // USA
  "sofi": "SoFi Stadium",
  "los angeles": "SoFi Stadium",
  "la": "SoFi Stadium",
  "inglewood": "SoFi Stadium",
  "metlife": "MetLife Stadium",
  "new york": "MetLife Stadium",
  "new jersey": "MetLife Stadium",
  "ny": "MetLife Stadium",
  "nj": "MetLife Stadium",
  "east rutherford": "MetLife Stadium",
  "att": "AT&T Stadium",
  "at&t": "AT&T Stadium",
  "dallas": "AT&T Stadium",
  "arlington": "AT&T Stadium",
  "cowboys": "AT&T Stadium",
  "hard rock": "Hard Rock Stadium",
  "miami": "Hard Rock Stadium",
  "miami gardens": "Hard Rock Stadium",
  "dolphins": "Hard Rock Stadium",
  "nrg": "NRG Stadium",
  "houston": "NRG Stadium",
  "texans": "NRG Stadium",
  "mercedes benz": "Mercedes-Benz Stadium",
  "mercedes-benz": "Mercedes-Benz Stadium",
  "atlanta": "Mercedes-Benz Stadium",
  "falcons": "Mercedes-Benz Stadium",
  "lincoln": "Lincoln Financial Field",
  "philadelphia": "Lincoln Financial Field",
  "philly": "Lincoln Financial Field",
  "eagles": "Lincoln Financial Field",
  "lumen": "Lumen Field",
  "seattle": "Lumen Field",
  "centurylink": "Lumen Field",
  "seahawks": "Lumen Field",
  "levis": "Levi's Stadium",
  "levi's": "Levi's Stadium",
  "san francisco": "Levi's Stadium",
  "sf": "Levi's Stadium",
  "santa clara": "Levi's Stadium",
  "49ers": "Levi's Stadium",
  "arrowhead": "Arrowhead Stadium",
  "kansas city": "Arrowhead Stadium",
  "kc": "Arrowhead Stadium",
  "chiefs": "Arrowhead Stadium",
  "gillette": "Gillette Stadium",
  "boston": "Gillette Stadium",
  "foxborough": "Gillette Stadium",
  "patriots": "Gillette Stadium",
  
  // Canada
  "bmo": "BMO Field",
  "toronto": "BMO Field",
  "bc place": "BC Place",
  "vancouver": "BC Place",
};

// Stage aliases
const STAGE_ALIASES = {
  "group a": "Group A", "groupe a": "Group A", "ga": "Group A",
  "group b": "Group B", "groupe b": "Group B", "gb": "Group B",
  "group c": "Group C", "groupe c": "Group C", "gc": "Group C",
  "group d": "Group D", "groupe d": "Group D", "gd": "Group D",
  "group e": "Group E", "groupe e": "Group E", "ge": "Group E",
  "group f": "Group F", "groupe f": "Group F", "gf": "Group F",
  "group g": "Group G", "groupe g": "Group G", "gg": "Group G",
  "group h": "Group H", "groupe h": "Group H", "gh": "Group H",
  "r32": "Round of 32", "round 32": "Round of 32", "32eme": "Round of 32", "32èmes": "Round of 32",
  "r16": "Round of 16", "round 16": "Round of 16", "16eme": "Round of 16", "16èmes": "Round of 16", "8eme": "Round of 16",
  "qf": "Quarterfinal", "quart": "Quarterfinal", "quarter": "Quarterfinal", "quarterfinal": "Quarterfinal",
  "sf": "Semifinal", "semi": "Semifinal", "demi": "Semifinal", "semifinal": "Semifinal",
  "3rd": "Third Place", "third": "Third Place", "3eme": "Third Place", "petite finale": "Third Place",
  "final": "Final", "finale": "Final", "f": "Final",
};

/**
 * Normalize match number from various formats
 * Examples: "057", "M57", "match 57", "57" -> 57
 */
export const normalizeMatchNumber = (input) => {
  if (!input) return null;
  const str = String(input).trim().toLowerCase();
  
  // Extract number from various formats
  const patterns = [
    /^m?(\d{1,3})$/i,           // M57, 057, 57
    /^match\s*(\d{1,3})$/i,     // match 57, match57
    /^game\s*(\d{1,3})$/i,      // game 57
    /^partido\s*(\d{1,3})$/i,   // partido 57
    /^#(\d{1,3})$/i,            // #57
  ];
  
  for (const pattern of patterns) {
    const match = str.match(pattern);
    if (match) {
      const num = parseInt(match[1], 10);
      if (num >= 1 && num <= 80) return num;
    }
  }
  
  // Direct number
  const directNum = parseInt(str, 10);
  if (!isNaN(directNum) && directNum >= 1 && directNum <= 80) {
    return directNum;
  }
  
  return null;
};

/**
 * Get match by match number
 */
export const getMatchByNumber = (matchNum) => {
  const num = typeof matchNum === 'number' ? matchNum : normalizeMatchNumber(matchNum);
  if (!num) return null;
  return WC_MATCHES.find(m => m.matchNum === num);
};

/**
 * Normalize venue name from alias
 */
export const normalizeVenue = (input) => {
  if (!input) return null;
  const normalized = input.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  return VENUE_ALIASES[normalized] || input;
};

/**
 * Normalize stage/phase name from alias
 */
export const normalizeStage = (input) => {
  if (!input) return null;
  const normalized = input.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  return STAGE_ALIASES[normalized] || input;
};

/**
 * Generate full match name for display
 * Example: "M57 Japan vs TBD - Round of 32 - Seattle"
 */
export const getMatchDisplayName = (matchNum) => {
  const match = getMatchByNumber(matchNum);
  if (!match) return null;
  return `M${match.matchNum} ${match.teams} - ${match.stage} - ${match.city}`;
};

/**
 * Normalize World Cup ticket data during import
 * @param {Object} ticket - Raw ticket data
 * @returns {Object} Normalized ticket data
 */
export const normalizeWCTicket = (ticket) => {
  const result = { ...ticket };
  
  // Try to get match number from various fields
  let matchNum = null;
  
  // Check common field names for match number
  const matchFields = ['match', 'match_num', 'matchnum', 'numero_match', 'evenement', 'event', 'ref'];
  for (const field of matchFields) {
    if (ticket[field]) {
      matchNum = normalizeMatchNumber(ticket[field]);
      if (matchNum) break;
    }
  }
  
  // If we found a match number, get full match info
  if (matchNum) {
    const match = getMatchByNumber(matchNum);
    if (match) {
      // Auto-fill match information
      result.evenement = result.evenement || getMatchDisplayName(matchNum);
      result.date_evenement = result.date_evenement || match.date;
      result.lieu = result.lieu || match.venue;
      result.ville = result.ville || match.city;
      result.phase = result.phase || match.stage;
      result.match_num = matchNum;
    }
  }
  
  // Normalize venue if provided
  if (result.lieu) {
    result.lieu = normalizeVenue(result.lieu);
  }
  
  // Normalize stage if provided
  if (result.phase) {
    result.phase = normalizeStage(result.phase);
  }
  
  return result;
};

/**
 * Smart detect match from partial data
 * @param {string} input - Any text that might contain match info
 * @returns {Object|null} Match info if detected
 */
export const detectMatchFromText = (input) => {
  if (!input) return null;
  const str = String(input).trim();
  
  // Try direct match number
  const matchNum = normalizeMatchNumber(str);
  if (matchNum) {
    return getMatchByNumber(matchNum);
  }
  
  // Try to find match number in the text
  const patterns = [
    /m(\d{1,3})/i,
    /match\s*(\d{1,3})/i,
    /\b(\d{1,3})\b/,
  ];
  
  for (const pattern of patterns) {
    const match = str.match(pattern);
    if (match) {
      const num = parseInt(match[1], 10);
      if (num >= 1 && num <= 80) {
        return getMatchByNumber(num);
      }
    }
  }
  
  return null;
};

export default {
  WC_MATCHES,
  normalizeMatchNumber,
  getMatchByNumber,
  normalizeVenue,
  normalizeStage,
  getMatchDisplayName,
  normalizeWCTicket,
  detectMatchFromText,
};
